export default __webpack_public_path__ + "ebf79e27505da85b1607757530ab4030.svg";